import { useEffect, useState } from "react";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { ASSETS } from "../lib/assets";

const links = [
  { id: "home", label: "Home" },
  { id: "services", label: "Services" },
  { id: "founder", label: "Founder" },
  { id: "process", label: "Process" },
  { id: "contact", label: "Contact" },
];

export const Navbar = () => {
  const [active, setActive] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 30);
      // detect section in view
      const offsets = links.map((l) => {
        const el = document.getElementById(l.id);
        if (!el) return { id: l.id, top: Infinity };
        const rect = el.getBoundingClientRect();
        return { id: l.id, top: Math.abs(rect.top - 120) };
      });
      offsets.sort((a, b) => a.top - b.top);
      if (offsets[0]) setActive(offsets[0].id);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-black/80 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-28 flex items-center justify-between">
        <button
          data-testid="logo-home-btn"
          onClick={() => go("home")}
          className="flex items-center shrink-0"
        >
          <img
            src={ASSETS.logo}
            alt="Velora"
            className="h-[100px] w-auto object-contain -ml-2 sm:-ml-3"
            style={{ filter: "brightness(1.15) contrast(1.05)" }}
          />
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}-btn`}
              onClick={() => go(l.id)}
              className={`nav-link text-sm tracking-wide ${
                active === l.id ? "text-[rgb(182,245,0)] active" : "text-white/80 hover:text-white"
              }`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="lets-talk-btn"
          onClick={() => go("contact")}
          className="hidden md:inline-flex btn-lime items-center gap-2 px-5 py-2.5 rounded-full font-semibold text-sm"
        >
          Let&apos;s Talk <ArrowUpRight className="w-4 h-4" />
        </button>

        <button
          data-testid="mobile-menu-btn"
          onClick={() => setOpen(!open)}
          className="md:hidden text-white p-2"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-black/95 border-t border-white/5 px-5 py-6 space-y-3"
        >
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-${l.id}-btn`}
              onClick={() => go(l.id)}
              className={`block w-full text-left text-lg font-display py-2 ${
                active === l.id ? "text-[rgb(182,245,0)]" : "text-white"
              }`}
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="mobile-lets-talk-btn"
            onClick={() => go("contact")}
            className="btn-lime w-full mt-3 px-5 py-3 rounded-full font-semibold inline-flex items-center justify-center gap-2"
          >
            Let&apos;s Talk <ArrowUpRight className="w-4 h-4" />
          </button>
        </div>
      )}
    </header>
  );
};
